import type { BifrostImage, BifrostWeb } from '@seekrtech/bifrost-web'
import type { Result } from '../types'

export type { BifrostImage }
export { bifrostImageToDataUrl } from '@seekrtech/bifrost-web'

export interface AssetsServiceMethods {
  getImageByName: (name: string) => Promise<Result<BifrostImage, 'not found'>>
}

export function createAssetsService(bifrost: BifrostWeb): AssetsServiceMethods {
  return bifrost.createNativeProxy<AssetsServiceMethods>('AssetsService')
}
